export const STOCK_ENREGISTRER = 'stock/STOCK_ENREGISTRER';
export const STOCK_LISTER = 'stock/STOCK_LISTER';
